import { NodeViewWrapper } from "@tiptap/react";
import clientApproach from '../../../../../assets/images/whtchoosemalmart/icon-approach.png'
import communication from '../../../../../assets/images/whtchoosemalmart/icon-communication.png'
import data from '../../../../../assets/images/whtchoosemalmart/icon-data.png'
import dataProcess from '../../../../../assets/images/whtchoosemalmart/icon-process.png'
import clientProfessionals from '../../../../../assets/images/whtchoosemalmart/icon-professionals.png'
import trackRecord from '../../../../../assets/images/whtchoosemalmart/icon-track-record.png'

const whyChooseData = [
    {
      imagePath: clientProfessionals,
      title: "100% Transparency",
      description:
        "Clear pricing, no hidden costs, and complete visibility at every stage.",
    },
    {
      imagePath: communication,
      title: "Dedicated project manager",
      description:
        "Tailored solutions that adapt to your vision throughout.",
    },
    {
      imagePath: data,
      title: "Regular updates and site reports",
      description:
        "A single point of contact ensuring smooth coordination.",
    },
    {
      imagePath: trackRecord,
      title: "Customization at every stage",
      description:
        "Continued support and assurance even after handover.",
    },
    {
      imagePath: clientApproach,
      title: "Warranty and post construction support",
      description:
        "Stay informed with consistent progress tracking.",
    },
    {
      imagePath: dataProcess,
      title: "Our Construction Process",
      description:
        "A structured, step-by-step approach for seamless execution.",
    },
];

export const WhyHomeOwnersTrustUsBlockView = (props) => {
    const { editor, getPos } = props;

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <NodeViewWrapper data-type='whyhomeownerstrustus'>
            <div className="offers-node-wrapper">
                <div onClick={handleCaptionClick}>
                    <div className='offers-content'>
                        <h5>Why Home Owners Trust Us</h5>
                        <div className="offers-grid">
                            {whyChooseData.map((item, index) => (
                                <div key={index} className="offers-item">
                                    <div className="offers-image">
                                        <img src={item.imagePath} alt={item.title} />
                                    </div>
                                    <h3 className="offers-title">{item.title}</h3>
                                    <p className="offers-description">{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    );
};